module.exports = __webpack_public_path__ + "img/close_transparent.1f8c59d7.svg";